import React, { useState, useEffect, useRef } from 'react';
import { fullFillmentList } from 'shared/settings/apiconfig';
import { useHistory } from 'react-router-dom';
import Datatable from 'shared/datatable';
import { capitalizeFirstLetter } from 'shared/utils';
import moment from 'moment';
import * as momentTz from 'moment-timezone';
const PickupItems = ({ filter, fullfillmentStatus, saleid, state }) => {
    const history = useHistory();
    const initialSearchState = {
        saleid: { field: "saleid", value: saleid, op: "=", join: "AND" },
        // irm: { field: "irm", value: "pickup", op: "like", join: "AND" }
    };

    const datatable = useRef(null);
    const customirm = (value) => {
        if (value.fullfillmentirmstatus) {
            const irmStatus = {
                pickup: 'Pickup',
                ship: 'Shipping',
                deliver: 'Delivery',
            };

            return irmStatus[value.fullfillmentirmstatus || '- - -'] || '- - -';
        }
    };

    const customPickupDate = (values) => {
        if (values.pickupdate) {
            const date = moment.utc(values.pickupdate).local();
            return date.format('MM/DD/YYYY');
        }
        return '- - -';
    };

    const customPickupTime = (values) => {
        if (values.pickupdate) {
            const date = moment.utc(values.pickupdate).local();
            return `${date.format('hh:mm A')} ${momentTz.tz(momentTz.tz.guess()).zoneAbbr()}`;
        }
        return '- - -';
    };
    const customeName = (value) => {
      return value.datatransferstatus ? capitalizeFirstLetter(value.datatransferstatus) : '- - -';
    }
    const customInvoiceNumber = (values) => {
        return (<span style={{ color: "blue", cursor: "pointer" }} onClick={() => invoiceview(values.invoiceid)}>{values['invoicenumber'] ? values['invoicenumber'] : '- - -'}</span>);
    }
    const invoiceview = (invid) => {
        history.push({ pathname: `/invoice/view/${invid}`, state: { name: "Saledashboard", prevPath: `/sales/dashboard/${saleid}`,state } })
    }



    const [search, setSearch] = useState({ ...initialSearchState, ...filter });

    useEffect(() => {
        const mergedFilter = { ...initialSearchState, ...filter };
        setSearch(mergedFilter);
    }, [filter]);

    useEffect(() => {
        if (fullfillmentStatus) {
            if (datatable.current) {
                datatable.current.searchData();
            }
        }

    }, [search]);

    const config = {
        name: 'fullfillment',
        url: fullFillmentList,
        params: {},
        columns: [
            { name: 'Data Transfer Status', property: 'datatransferstatus', sort: false, width: '200px',columnType: 'custom', customColumn: customeName  },
            { name: 'Item Title', property: 'itemtitle', sort: false, width: '200px' },
            { name: 'Invoice Number', property: 'invoicenumber', sort: false, width: '150px',columnType: 'custom', customColumn: customInvoiceNumber },
            { name: 'Email', property: 'buyeremail', sort: false, width: '150px' },
            { name: 'Pickup Date', property: 'pickupdate', sort: false, width: '120px',columnType: 'custom', customColumn: customPickupDate },
            { name: 'Pickup Time', property: 'pickupdate', sort: false, width: '120px',columnType: 'custom', customColumn: customPickupTime },
            { name: 'Item Receipt Method', property: 'fullfillmentirmstatus', sort: false, width: '150px', columnType: 'custom', customColumn: customirm }
        ],
        field: ["id","itemid","carrier", "trackingnumber", "shippingvendor", "itemtitle","irm","invoicenumber","invoiceid","buyeremail", "shipmentstatus","fullfillmentirmstatus","datatransferstatus","pickupdate","pickuptime"],
        defaultFilter: [{field: "fullfillmentirmstatus", value: "pickup", op: "=", join: "AND" }],
        sort: [{ field: 'id', direction: 'desc' }],
        pagination: true,
        ignoreRowBackground: true
    };

   

    return (
        <div className="" style={{ width: '100%' }}>
            <Datatable config={{ ...config }} search={{ search: { ...search }, searchData: fullfillmentStatus ?  false : true }} ref={datatable} ></Datatable>
        </div>
    );
};

export default PickupItems;
